































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Tzsb extends Vue {
    @Prop({ default: new Date().getFullYear() - 1 })
    year!: number;

    id: number | null = null;
    allNum:any = "";
    safeNum:any = "";
    form:any = {}

    mounted() {
        this.fetchData();
    }

    addData() {
        this.form.allNum = (+this.form.boilerRegisterNum)+(+this.form.pressureVesselRegisterNum)+(+this.form.elevatorRegisterNum)+(+this.form.liftMachineryRegisterNum)+(+this.form.passengerRopeWayRegisterNum)+(+this.form.playFacilityRegisterNum)+(+this.form.motorVehicleRegisterNum)   
        this.form.safeNum = (+this.form.boilerSafeNum)+(+this.form.pressureVesselSafeNum)+(+this.form.elevatorSafeNum)+(+this.form.liftMachinerySafeNum)+(+this.form.passengerRopeWaySafeNum)+(+this.form.playFacilitySafeNum)+(+this.form.motorVehicleSafeNum)
    }

    async fetchData() {
        const res = await Vue.axios.get(`gsnb/tzsbxx/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        this.allNum = res.data.data.allNum;
        this.safeNum = res.data.data.safeNum;
        this.form = res.data.data
        this.id = res.data.data.id;
    }

    async saveData() {
        if(this.$store.state.accountBook.accountBookInfo.province ===  "辽宁省") {
            await Vue.axios.post(`gsnb/tzsbxx/save`, this.form);
        }
        else {
            await Vue.axios.post(`gsnb/tzsbxx/save`, {
                 id: this.id,
                 allNum: this.allNum,
                 safeNum: this.safeNum,
                 year: this.year,
                 accountBookId: this.$store.state.accountBook.id
            });
        }
        this.fetchData();
    }
}
